import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';

export default class NodeSetPivot extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.FLOAT, 'x_perc', 0, { minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'y_perc', 0, { minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'z_perc', 0, { minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });

		this.addInput(PARAM_TYPE.BBOX, 'reference', null);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');

		this.addOutput(PARAM_TYPE.FLOAT, 'pivot_x');
		this.addOutput(PARAM_TYPE.FLOAT, 'pivot_y');
		this.addOutput(PARAM_TYPE.FLOAT, 'pivot_z');
	}

	getType()
	{
		return 'setPivot';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		let bbox;
		if(inputValues['reference'])
			bbox = inputValues['reference'];
		else
			bbox = Utils3D.getObjectsBBoxWithChildren(pGeoList);

		let vecWorldPivot = new BABYLON.Vector3(0, 0, 0);

		const fXInterp = (inputValues['x_perc']/100.0 + 1.0)/2.0;
		vecWorldPivot.x = bbox.maximumWorld.x*fXInterp + bbox.minimumWorld.x*(1.0 - fXInterp);

		const fYInterp = (inputValues['y_perc']/100.0 + 1.0)/2.0;
		vecWorldPivot.y = bbox.maximumWorld.y*fYInterp + bbox.minimumWorld.y*(1.0 - fYInterp);

		const fZInterp = (inputValues['z_perc']/100.0 + 1.0)/2.0;
		vecWorldPivot.z = bbox.maximumWorld.z*fZInterp + bbox.minimumWorld.z*(1.0 - fZInterp);

		if(outputName == 'geo')
		{
			for(let pSrcMesh of pGeoList)
				Utils3D.setWorldPivot(pSrcMesh, vecWorldPivot);
			return pGeoList;
		}
		else if(outputName == 'pivot_x')
			return vecWorldPivot.x;
		else if(outputName == 'pivot_y')
			return vecWorldPivot.y;
		else if(outputName == 'pivot_z')
			return vecWorldPivot.z;
	}
}